const formatDuration = (totalSeconds) => {
    const hours = Math.floor(totalSeconds / 3600); // Get total hours
    const minutes = Math.floor((totalSeconds % 3600) / 60); // Get remaining minutes
    const seconds = Math.floor(totalSeconds % 60); // Get remaining seconds

    return `${hours}h ${minutes}m ${seconds}s`;
};
export default formatDuration;